import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import oneimpor from './oneimpor'

Vue.use(Vuex)
export default new Vuex.Store({
    modules: {
        user,
        oneimpor
    }
})